import { ID, Task, UpdateTask } from '@griply/types';

// Computes the parent-task update needed to attach freshly-duplicated tasks:
// each new id is inserted directly below its original in subtaskOrder, and any
// new task whose original isn't in the existing order is appended.
export const getDuplicatedParentTaskUpdate = (
  parentTask: Task,
  tasksToAttach: Task[],
  oldToNewTaskMap: Map<ID, Task>,
): UpdateTask => {
  const newChildIds = tasksToAttach.map(({ id }) => id);
  const tasksToAttachIds = new Set(newChildIds);

  const existingOrder = Array.from(
    new Set([
      ...(parentTask.subtaskOrder ?? []),
      ...(parentTask.childIds ?? []),
    ]),
  );

  const processedNewIds = new Set<ID>();
  const subtaskOrder: ID[] = [];
  existingOrder.forEach((existingId) => {
    subtaskOrder.push(existingId);

    const newTask = oldToNewTaskMap.get(existingId);
    if (newTask && tasksToAttachIds.has(newTask.id)) {
      subtaskOrder.push(newTask.id);
      processedNewIds.add(newTask.id);
    }
  });

  tasksToAttach.forEach(({ id }) => {
    if (!processedNewIds.has(id)) {
      subtaskOrder.push(id);
    }
  });

  return {
    id: parentTask.id,
    childIds: [...(parentTask.childIds ?? []), ...newChildIds],
    subtaskOrder,
  };
};
